(function () {
  // Tente de récupérer la note King-Avis affichée sur la page (option C).
  // Si rien n'est trouvé, la valeur manuelle du thème reste affichée (option B).

  function parseRating(text) {
    if (!text) return null;
    var m = text.replace(',', '.').match(/([0-5](?:\.\d{1,2})?)\s*\/\s*5/);
    if (m) return parseFloat(m[1]);
    return null;
  }

  // 1) Source la plus fiable : données structurées JSON-LD (aggregateRating)
  function fromJsonLd() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        var arr = Array.isArray(data) ? data : [data];
        for (var j = 0; j < arr.length; j++) {
          var node = arr[j];
          var ar = node && node.aggregateRating;
          if (ar && ar.ratingValue) {
            var v = parseFloat(String(ar.ratingValue).replace(',', '.'));
            if (v >= 0 && v <= 5) {
              return { value: v, count: ar.reviewCount || ar.ratingCount || null };
            }
          }
        }
      } catch (e) {}
    }
    return null;
  }

  // 2) Repli : lire la note dans le DOM du widget King-Avis flottant
  function fromWidget() {
    var sel =
      '[id*="king-avis"],[class*="king-avis"],[id*="kingavis"],[class*="kingavis"],' +
      '[id*="ka-widget"],[class*="ka-widget"],[id*="ka_widget"],[class*="ka_widget"]';
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      var r = parseRating(nodes[i].textContent);
      if (r != null) return { value: r, count: null };
    }
    return null;
  }

  function applyRating(res) {
    if (!res || res.value == null) return false;
    var targets = document.querySelectorAll('a[href*="king-avis"] .reassurance-rating');
    if (!targets.length) return false;
    var val = res.value.toFixed(1).replace(/\.0$/, '');
    for (var i = 0; i < targets.length; i++) {
      targets[i].textContent = val + '/5';
      targets[i].setAttribute('data-king-avis-live', 'true');
    }
    return true;
  }

  function tryUpdate() {
    return applyRating(fromJsonLd() || fromWidget());
  }

  // Le widget se charge en asynchrone : on retente quelques secondes.
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (tryUpdate() || attempts >= 12) clearInterval(timer);
  }, 1000);

  if (document.readyState !== 'loading') tryUpdate();
  else document.addEventListener('DOMContentLoaded', tryUpdate);
})();
